import Swal from 'sweetalert2';
import { useMapEvents, Marker } from 'react-leaflet';
import { useState } from 'react';

function LocationMarker({ onLocationSelect, currentPosition }) {
    const [tempPosition, setTempPosition] = useState(currentPosition);

    useMapEvents({
        click(e) {
            setTempPosition(e.latlng); // Geser marker dulu ke posisi baru
            Swal.fire({
                title: 'Pindah lokasi?',
                text: 'Apakah Anda yakin ingin pindah ke lokasi ini?',
                icon: 'warning',
                position: 'center',
                showCancelButton: true,
                confirmButtonText: 'Ya, pindah',
                cancelButtonText: 'Batal',
            }).then((result) => {
                if (result.isConfirmed) {
                    onLocationSelect(e.latlng); // Konfirmasi pindah
                    Swal.fire({
                        title: 'Lokasi dipindahkan!',
                        icon: 'success',
                        position: 'top-end', // Pindahin ke atas
                        timer: 1000,
                        timerProgressBar: true,
                        toast: true, // Mode toast
                        showConfirmButton: false,
                    });
                } else {
                    setTempPosition(currentPosition); // Batal, balik ke posisi semula
                }
            });
        },
    });

    return <Marker position={tempPosition} />;
}

export default LocationMarker;